import React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";

interface EpisodeArtworkProps {
  imageUrl?: string;
  altText?: string;
  size?: number;
}

const EpisodeArtwork = ({
  imageUrl = "https://dummyimage.com/120/f4f4f4/666666&text=Episode+Artwork",
  altText = "Episode artwork",
  size = 120,
}: EpisodeArtworkProps) => {
  return (
    <div
      className="bg-white rounded-lg overflow-hidden shadow-md"
      style={{ width: size, height: size }}
    >
      <AspectRatio ratio={1}>
        <img
          src={imageUrl}
          alt={altText}
          className="object-contain w-full h-full"
        />
      </AspectRatio>
    </div>
  );
};

export default EpisodeArtwork;
